Ext.define('SA.view.sidebar.data.DataSidebar', {
    alias: 'widget.data-sidebar',
    extend: 'SA.view.SimpleContainer',

    initComponent() {
        this.items = [
            {
                xtype: 'sa-search-field',
                cls: 'sa-sidebar-search-field',
                emptyText: 'Data Search',
                favoritesButtonTitle: 'Favorite Data Variables',
                itemId: 'dataSearchField',
                recentButtonTitle: 'Recent Data Variables',

                recentList: {
                    xtype: 'recent-attributes-list',

                    favorites: {
                        source: SA.data.FavoriteAttributes,
                        title: 'Favorite Data'
                    },

                    recent: {
                        source: SA.data.RecentAttributes,
                        title: 'Recent Data'
                    }
                }
            }, {
                xtype: 'data-sidebar-header'
            }, {
                xtype: 'data-categories-grid'
            }, {
                xtype: 'data-folders-list',
                hidden: true
            }, {
                xtype: 'imports-data-browse-window',
                hidden: true
            }
        ];

        this.callParent();

        this.dataCategoriesGrid = this.down('data-categories-grid');
        this.dataFoldersList = this.down('data-folders-list');
        this.searchField = this.down('#dataSearchField');
        this.dataSidebarHeader = this.down('data-sidebar-header');
        this.importsDataBrowseWindow = this.down('imports-data-browse-window');

        this.vendorDatasetSort = new SA.data.VendorDatasetSort();
        this.lastSelectedEditionOptionsByCensusReleaseId = new SA.view.sidebar.data.DataSidebar.LastSelectedEditionOptionsByCensusReleaseId();
    },

    afterHide() {
        this.callParent(arguments);

        this.clearSearchField();
    },

    clearSearchField() {
        this.searchField.setValue('');
    },

    clearSearchFieldUnlessFocused() {
        setTimeout(() => {
            if (!this.searchField.isFocused()) {
                this.clearSearchField();
            }
        }, 0);
    },

    getBrowseOrSearchWindowResultAttributeIds() {
        if (this.browseWindow?.isVisible()) {
            return this.browseWindow.getResultAttributeIds();
        }
        else if (this.searchWindow?.isVisible()) {
            return this.searchWindow.getResultAttributeIds();
        }

        return [];
    },

    getBrowseWindow(create) {
        var me = this,
            browseWindow = this.browseWindow;

        if (!browseWindow && create !== false) {
            browseWindow = this.browseWindow = Ext.widget({
                xtype: 'data-folders-browser',
                location: this.view.getDataFoldersFilterLocation(),

                listeners: {
                    hide: this.onBrowseWindowHide,
                    select: this.onSelect,

                    scope: this
                },

                plugins: [
                    {
                        ptype: 'close-on-click-outside',

                        getSafeElements() {
                            var defaultEls = SA.view.plugin.CloseOnClickOutside.prototype.getSafeElements.call(this),
                                nonImportFolderEls = me.dataFoldersList.getNonImportFolderEls();

                            return [...defaultEls, ...nonImportFolderEls];
                        }
                    }, {
                        ptype: 'sa-arrow'
                    }
                ]
            });

            this.updateSelectedAttributes();
        }

        return browseWindow;
    },

    getSearchFieldValue() {
        return this.searchField.getValue().trim();
    },

    getSearchWindow(create) {
        var me = this,
            searchWindow = this.searchWindow;

        if (!searchWindow && create !== false) {
            searchWindow = this.searchWindow = Ext.widget({
                xtype: 'data-search-window',

                listeners: {
                    hide: this.onSearchWindowHide,
                    select: this.onSelect,
                    'clear:text': this.clearSearchField,
                    'click:path': this.onSearchWindowPathClick,

                    scope: this
                },

                plugins: [
                    {
                        ptype: 'close-on-click-outside',

                        getSafeElements() {
                            var defaultEls = SA.view.plugin.CloseOnClickOutside.prototype.getSafeElements.call(this),
                                nonImportsCategoryItemEls = me.dataCategoriesGrid.getNonImportsItemEls();

                            return [...defaultEls, ...nonImportsCategoryItemEls];
                        }
                    }, {
                        ptype: 'sa-arrow'
                    }
                ]
            });

            this.updateSelectedAttributes();
        }

        return searchWindow;
    },

    hideImportsBrowser() {
        this.importsDataBrowseWindow.hide();
    },

    hideVariableBrowser() {
        var win = this.getBrowseWindow(false);

        if (win) {
            win.hide();
        }
    },

    hideVariableSearch() {
        var win = this.getSearchWindow(false);

        if (win) {
            win.hide();
        }
    },

    initEvents() {
        this.callParent();

        document.addEventListener('keydown', ev => {
            if (ev.code === 'Escape') {
                this.onEscKeyDown();
            }
        }, {capture: true});

        SA.EventBus.on('metadata-window:click:path', this.onMetadataWindowPathClick, this);

        this.importsDataBrowseWindow.on('select:attribute', this.onSelect, this);
        this.importsDataBrowseWindow.on('mousedown:outside', this.onMousedownOutsideImportsDataBrowseWindow, this);
        this.importsDataBrowseWindow.on('hide', this.onHideImportsDataBrowseWindow, this);

        this.searchField.on('select', this.onSelect, this);
        this.searchField.on('enterkeypress', this.onSearchFieldEnterKeyPress, this);

        this.dataSidebarHeader.on('change:browseBy', this.setBrowseByCategory, this);
        this.dataSidebarHeader.on('change:editionOption', this.onChangeEditionOption, this);

        this.dataFoldersList.on('select', this.onFolderSelect, this);
        this.dataFoldersList.on('deselect', this.onFolderDeselect, this);

        this.dataCategoriesGrid.on('select', this.onCategoriesGridSelect, this);
        this.dataCategoriesGrid.on('deselect', this.onCategoriesGridDeselect, this);
    },

    onCategoriesGridDeselect() {
        this.hideImportsBrowser();
        this.hideVariableSearch();
    },

    onCategoriesGridSelect(category) {
        var arrowTarget = this.dataCategoriesGrid.getItemEl(category);

        if (SA.data.CountryCategoryList.isImportsCategoryId(category)) {
            this.hideVariableSearch();
            this.showImportsBrowser({arrowTarget});
        }
        else {
            this.hideImportsBrowser();
            this.showVariableSearch({arrowTarget, category});
        }
    },

    onChangeEditionOption(editionOption) {
        this.editionOption = editionOption;

        this.lastSelectedEditionOptionsByCensusReleaseId.set(this.censusReleaseId, editionOption);

        this.dataSidebarHeader.setEditionOption(editionOption);
        this.refreshDataFoldersList();
    },

    refreshDataFoldersList() {
        if (!this.view || this.view.getType() === 'project') {
            return;
        }

        var editionOption = this.editionOption,
            vendorDatasetSort = this.vendorDatasetSort,
            censusReleaseYear = this.view.getCensusReleaseYear(),
            datasets = this.view.getSupportedDatasetModels().filter(dataset => dataset.getVendorName() !== 'EASI'),
            permitWrapping = dataset => dataset.getId() === 'CCHS', 
            datasetAvailable = dataset => editionOption.isLatest() || dataset.hasEditionInCensusRelease({edition: editionOption.getYear(), censusReleaseYear}),
            packages = [
                    ['My Imported Data', dataset => dataset.isImport()],
                    ['Standard Data Package', dataset => dataset.isStandard()],
                    ['Premium Data', dataset => dataset.isPremium()]
                ]
                .map(([name, predicate]) => [name, datasets.filter(dataset => dataset.hasFolders()).filter(predicate)])
                .filter(([, datasets]) => datasets.length > 0)
                .map(([name, datasets]) => {
                    var vendors = SA.Array.group(datasets, dataset => dataset.getVendorName())
                        .map(([name, datasets]) => {
                            var datasets = datasets
                                    .map(dataset => {
                                        return {
                                            id: dataset.getId(),
                                            name: dataset.getName(),
                                            available: datasetAvailable(dataset),
                                            permitWrapping: permitWrapping(dataset)
                                        };
                                    })
                                    .sort(vendorDatasetSort.getDatasetSort()),
                                imports = SA.data.Vendors.isImportsVendorName(name),
                                available = datasets.some(dataset => dataset.available);

                            return {name, imports, available, datasets};
                        })
                        .sort(vendorDatasetSort.getVendorSort());

                    return {name, vendors};
                });

        this.dataFoldersList.update(packages);
    },

    onFolderSelect({dataset, el}) {
        var isImport = SA.data.UserDatasets.isUserDataset(dataset);

        if (isImport) {
            this.hideVariableBrowser();
            this.showImportsBrowser({arrowTarget: el, dataset});
        }
        else {
            this.hideImportsBrowser();
            this.showVariableBrowser({arrowTarget: el, dataset, editionOption: this.editionOption});
        }
    },

    onFolderDeselect() {
        this.hideImportsBrowser();
        this.hideVariableBrowser();
    },

    onBrowseWindowHide() {
        this.dataFoldersList.setSelected(null);

        Ext.destroyMembers(this, 'browseWindow');
    },

    onEscKeyDown() {
        if (!this.searchWindow?.isVisible() && !this.browseWindow?.isVisible()) {
            return;
        }

        if (SA.view.MetadataWindow.instanceVisible()) {
            SA.view.MetadataWindow.destroyInstance();
            return;
        }
        else if (SA.view.sidebar.data.DataSearchResultsAttribute.hasVisibleMenu()) {
            return; 
        }

        this.searchWindow?.hide();
        this.browseWindow?.hide();
    },

    onHideImportsDataBrowseWindow() {
        this.dataCategoriesGrid.setSelected(null);
        this.dataFoldersList.setSelected(null);
    },

    onMetadataWindowPathClick({arrowTarget, dataset, censusRelease, year, path, isUserAttribute}) {
        if (isUserAttribute) {
            this.showImportsBrowser({dataset});
            return;
        }

        var browseWindow = this.getBrowseWindow();

        if (browseWindow.isVisible()) {
            return; 
        }

        this.showVariableBrowser({censusRelease, dataset, editionOption: this.view.getEditionOptionForYear(year), path});
        this.hideVariableSearch();
    },

    onMousedownOutsideImportsDataBrowseWindow(mousedownEl) {
        var categoryEl = this.dataCategoriesGrid.getImportsItemEl(),
            datasetEls = this.dataFoldersList.getImportFolderEls(),
            allowHide = [categoryEl, ...datasetEls].every(el => !el.contains(mousedownEl));

        return allowHide;
    },

    onSearchFieldEnterKeyPress() {
        this.showVariableSearch({arrowTarget: this, text: this.getSearchFieldValue()});
    },

    onSearchWindowHide() {
        this.dataCategoriesGrid.setSelected(null);

        Ext.destroyMembers(this, 'searchWindow');

        this.clearSearchFieldUnlessFocused();
    },

    onSearchWindowPathClick(path, dataset, year) {
        this.showVariableBrowser({dataset, path, editionOption: this.view.getEditionOptionForYear(year)});
        this.hideVariableSearch();
    },

    onSelect(win, attribute) {
        this.useAttribute(attribute);
    },

    openDataFolder(attribute) {
        var {year, censusRelease, group: path, dataset_series: dataset} = SA.data.AttributesCache.get(attribute),
            editionOption = this.view.getEditionOptionForYear(year);

        this.showVariableBrowser({dataset, censusRelease, path, editionOption});
    },

    setBrowseByCategory(browseByCategory) {
        this.dataCategoriesGrid.setVisible(browseByCategory);
        this.dataFoldersList.setVisible(!browseByCategory);
    },

    setUseHandler(useHandler) {
        this.useHandler = useHandler;
    },

    setView(view) {
        if (view.getType() === 'project') {
            return;
        }

        var editionOptions = view.getEditionOptions(),
            censusReleaseId = this.censusReleaseId = view.getCensusReleaseId(),
            lastSelectedEditionOptionForCensusReleaseId = this.lastSelectedEditionOptionsByCensusReleaseId.get(censusReleaseId),
            editionOption = editionOptions.find(option => option.equals(lastSelectedEditionOptionForCensusReleaseId)) ?? view.getDefaultEditionOption(),
            latestEditionMenuItemText = view.hasLatestCensusRelease()
                ? 'Latest Release'
                : `Latest Year (${view.getCensusReleaseRange().join('–')} Geographies)`; 

        if (this.view?.getProject() !== view.getProject()) {
            this.clearSearchField();
        }

        this.view = view;
        this.editionOption = editionOption;

        Ext.destroy(this.viewAttributesListener);
        this.viewAttributesListener = view.on({'change:attribute': this.updateSelectedAttributes, scope: this, destroyable: true});

        this.searchField.setFilter(attribute => view.supportsAttribute(attribute));

        this.dataCategoriesGrid.setCategories(view.getCategories());
        this.importsDataBrowseWindow.setView(view);

        this.dataSidebarHeader.setEditionOptions(editionOptions);
        this.dataSidebarHeader.setEditionOption(editionOption);
        this.dataSidebarHeader.setLatestEditionMenuItemText(latestEditionMenuItemText);

        this.refreshDataFoldersList();
        this.updateSelectedAttributes();
    },

    showImportsBrowser({arrowTarget, dataset = null}) {
        this.importsDataBrowseWindow.view({arrowTarget, dataset});
        this.showWindow(this.importsDataBrowseWindow);
    },

    showVariableBrowser({arrowTarget, censusRelease = this.view.getCensusRelease(), dataset, editionOption, path = null}) {
        var win = this.getBrowseWindow(),
            datasetModel = SA.data.Vendors.getDatasetModel(dataset),
            datasetName = datasetModel.getName(),
            params = new SA.view.sidebar.data.ViewDataFoldersBrowserParams({censusRelease, dataset, editionOption, path}),
            year, titleYearText, title;

        if (editionOption.isLatest()) {
            year = datasetModel.getLatestEditionForCensusReleaseYear(censusRelease);
            titleYearText = this.view.hasLatestCensusRelease() ? 'Latest' : year;
        }
        else {
            year = editionOption.getYear();
            titleYearText = year;
        }

        title = `${Ext.String.htmlEncode(datasetName)} – ${titleYearText}`;

        win.setArrowTarget(arrowTarget);
        win.view({title, year, params});

        this.showWindow(win);
    },

    showVariableSearch({arrowTarget, category, text}) {
        var isNew = !this.getSearchWindow(false),
            win = this.getSearchWindow();

        win.setArrowTarget(arrowTarget);
        win.setText(text);
        win.setView(this.view);

        if (isNew) {
            let editionOption;

            if (this.dataFoldersList.isVisible()) {
                editionOption = this.editionOption;
            }
            else {
                editionOption = this.view.getDefaultEditionOption();
            }

            win.setYearFacet(editionOption.getYearFacetValue());
        }

        if (category) {
            win.selectCategory(category);
        }

        this.showWindow(win);
    },

    showWindow(win) {
        win.showAt(SA.Sidebar.getWidth() + 7, 50);

        win.el.dom.setAttribute('tabindex', 0);
        win.el.dom.focus();
        win.el.dom.removeAttribute('tabindex');
    },

    updateSelectedAttributes() {
        var view = this.view,
            attributes = view.getAttributes?.() ?? [],
            searchField = this.searchField,
            browseWindow = this.getBrowseWindow(false),
            importsWindow = this.importsDataBrowseWindow, 
            searchWindow = this.getSearchWindow(false);

        searchField.setSelected(attributes);

        if (browseWindow) {
            browseWindow.setSelectedVariables(attributes);
        }

        if (!importsWindow.hidden) {
            importsWindow.setSelectedVariables(attributes);
        }

        if (searchWindow) {
            searchWindow.setSelectedVariables(attributes);
        }
    },

    useAttribute(attribute) {
        if (this.useHandler) {
            this.useHandler(attribute);
            return;
        }

        var view = this.view,
            project = view.getProject(),
            hadAttributes = project.hasAttributes(),
            viewTypes = ['comparison', 'ranking'];

        view.addAttribute(attribute);

        if (!hadAttributes && project.hasAttributes()) {
            if (!project.hasBusinesses()) {
                viewTypes.splice(1, 0, 'map');
            }

            project.autoCreateViews(viewTypes);
        }

        view.save();

        SA.data.RecentAttributes.add(attribute);
        SA.Sidebar.fireUseItem('use:attribute', attribute);
    }
});
